'use client';

import { useEffect } from 'react';

export function AnchorScrollHandler() {
	useEffect(() => {
		function handleClick(e: MouseEvent) {
			const anchor = (e.target as Element).closest('a');
			if (!anchor) return;

			const href = anchor.getAttribute('href');
			if (!href?.startsWith('#')) return;

			const id = href.slice(1);
			if (!id) return;

			// If hash already matches, browser won't scroll — do it manually
			if (window.location.hash === href) {
				e.preventDefault();
				document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
			}
		}

		document.addEventListener('click', handleClick);
		return () => document.removeEventListener('click', handleClick);
	}, []);

	return null;
}
